import React from 'react'
import { useHistory } from 'react-router-dom'
import { useUser } from '@paintscout/ui-business'
import PainterAccountMenu from '../PainterScheduleView/PainterAccountMenu'
import { PainterMenuProvider, usePainterMenuContext } from './PainterMenuContext'
import { useFlags } from 'shared/components/common/FlagsProvider'

function PainterShellInner({ children }: { children: React.ReactNode }) {
  const { menuOpen, setMenuOpen, setNotificationsOpen } = usePainterMenuContext()
  const { user, isChurned, isTrial, trialExpired } = useUser()
  const { crm, painterAccount } = useFlags()
  const history = useHistory()
  const userAvatarUrl = user?.user_metadata?.customAvatar?.value
  const accessProhibited = isChurned || (isTrial && trialExpired) || !crm || !painterAccount

  return (
    <>
      {children}
      {menuOpen && (
        <PainterAccountMenu
          userAvatarUrl={userAvatarUrl}
          onClose={() => setMenuOpen(false)}
          {...(!accessProhibited && {
            onSchedule: () => {
              setMenuOpen(false)
              history.push('/scheduling/painter')
            },
            onProfile: () => {
              setMenuOpen(false)
              history.push('/profile')
            },
            onNotifications: () => {
              setMenuOpen(false)
              setNotificationsOpen(true)
              history.push('/scheduling/painter')
            }
          })}
          onRestart={() => window.location.reload()}
          onLogOut={() => {
            setMenuOpen(false)
            history.push('/logout')
          }}
        />
      )}
    </>
  )
}

export default function PainterShell({ children }: { children: React.ReactNode }) {
  return (
    <PainterMenuProvider>
      <PainterShellInner>{children}</PainterShellInner>
    </PainterMenuProvider>
  )
}
